<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="page-title">{{ $t('message.home.liveRooms') }}</div>

        <div class="filter-bar">
          <el-radio-group v-model="statusFilter" @change="handleFilter">
            <el-radio-button label="">{{ $t('message.home.all') }}</el-radio-button>
            <el-radio-button label="1">{{ $t('message.home.liveStreaming') }}</el-radio-button>
            <el-radio-button label="0">{{ $t('message.home.notStarted') }}</el-radio-button>
            <el-radio-button label="2">{{ $t('message.home.finished') }}</el-radio-button>
          </el-radio-group>
        </div>

        <div v-loading="loading">
          <div class="room-grid" v-if="list.length">
            <div class="room-card" v-for="item in list" :key="item.id" @click="goRoom(item)">
              <div class="cover-wrap">
                <img :src="item.coverImage || require('@/assets/image/01.png')" class="cover-img" alt="" />
                <span :class="['status-badge', 'status-' + item.liveStatus]">{{ statusLabels[item.liveStatus] }}</span>
              </div>
              <div class="room-info">
                <div class="room-title">{{ item.title }}</div>
                <div class="room-time">{{ item.beginTime }}</div>
              </div>
            </div>
          </div>
          <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
          <div class="common-pagination" v-if="total > 0">
            <el-pagination background layout="prev,pager,next,total" :page-size="queryParams.pageSize"
              :current-page="queryParams.pageNumber" :total="total" @current-change="currentChange" />
          </div>
        </div>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { listLiveRoom } from "@/api/marketing/live_room";

export default {
  name: "LiveList",
  data() {
    return {
      loading: false, list: [], total: 0, statusFilter: '',
      queryParams: { pageNumber: 1, pageSize: 20 },
    }
  },
  computed: {
    statusLabels() {
      return {
        0: this.$t('message.home.notStarted'),
        1: this.$t('message.home.liveStreaming'),
        2: this.$t('message.home.finished'),
        3: this.$t('message.home.finished'),
      }
    }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      const params = { ...this.queryParams }
      if (this.statusFilter !== '') params.liveStatus = this.statusFilter
      listLiveRoom(params).then(r => {
        this.list = r.data?.data?.content || []
        this.total = r.data?.data?.total || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleFilter() { this.queryParams.pageNumber = 1; this.loadData() },
    currentChange(page) { this.queryParams.pageNumber = page; this.loadData() },
    goRoom(item) { this.$router.push('/live/room/' + item.id) },
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.page-title { font-size: 22px; font-weight: bold; margin-bottom: 20px; }
.filter-bar { margin-bottom: 20px; }
.room-grid { display: flex; flex-wrap: wrap; gap: 16px; }
.room-card { background: #fff; border-radius: 8px; width: 280px; cursor: pointer; overflow: hidden; transition: box-shadow .2s; }
.room-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,.12); }
.cover-wrap { position: relative; }
.cover-img { width: 100%; height: 180px; object-fit: cover; display: block; }
.status-badge { position: absolute; top: 8px; left: 8px; font-size: 12px; padding: 2px 8px; border-radius: 10px; }
.status-0 { background: rgba(64,158,255,.85); color: #fff; }
.status-1 { background: rgba(103,194,58,.9); color: #fff; }
.status-2 { background: rgba(144,147,153,.7); color: #fff; }
.status-3 { background: rgba(245,108,108,.85); color: #fff; }
.room-info { padding: 12px; }
.room-title { font-size: 15px; font-weight: bold; color: #303133; margin-bottom: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.room-time { font-size: 13px; color: #909399; }
.common-pagination { margin-top: 24px; text-align: center; }
</style>
